import { signal, Signal, WritableSignal } from "@angular/core";

export abstract class GenericRepository<T> {
  protected data: WritableSignal<T[]> = signal<T[]>([])

  public constructor() {};

  public get getData(): Signal<T[]> {
    return this.data;
  }

  public setData(newData: T[]): void {
    this.data.set(newData);
  }

  public abstract fetch(): void;
}
